import React, { useEffect, useRef } from "react";
import { useAuthStore } from "../../stores/authStore";

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { checkAuth, isInitialized } = useAuthStore();
  const hasCheckedAuth = useRef(false);

  useEffect(() => {
    // Only check auth once on initial mount, and only if not already initialized
    if (!hasCheckedAuth.current && !isInitialized) {
      hasCheckedAuth.current = true;
      checkAuth();
    }

    // Optional: Set up periodic auth refresh every 5 minutes
    const interval = setInterval(
      () => {
        checkAuth();
      },
      5 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, [checkAuth, isInitialized]);

  return <>{children}</>;
};
